export function isSemanticallyEmpty(value: unknown): boolean {
    if (value == null) return true;

    if (Array.isArray(value)) {
        return value.length === 0 || value.every(isSemanticallyEmpty);
    }

    if (typeof value === 'object' && value !== null) {
        const obj = value as Record<string, unknown>;
        const keys = Object.keys(obj);
        return keys.length === 0 || keys.every((k) => isSemanticallyEmpty(obj[k]));
    }

    return false;
}
